// Utility function to determine if the currency symbol is on the left or right
//export function getCurrencyCultureSymbolOnLeftOrRight(cultureCode) {
//    const direction = (cultureCode === 'ar') ? 'right' : 'left';
//    const currencyPositivePatterns = [0, 1, 2, 3];

//    if (currencyPositivePatterns.includes(1) || currencyPositivePatterns.includes(3)) {
//        return 'right';
//    }
//    return direction;
//}

export function getCurrencyCultureSymbolOnLeftOrRight(cultureCode) {
  // Define the languages where the currency symbol appears on the right
  const rightSymbolLanguages = ['fr', 'de', 'es', 'pt', 'tr', 'ar'];
  // Define the languages where the currency symbol appears on the left
  const leftSymbolLanguages = ['en', 'us', 'zh', 'it', 'ja', 'ko'];

  // Check the culture code against predefined lists
  if (rightSymbolLanguages.includes(cultureCode)) {
    return 'right';
  } else if (leftSymbolLanguages.includes(cultureCode)) {
    return 'left';
  }

  // Default to left if culture code is not recognized
  return 'left';
}

// Convert amount to currency format based on language and symbol position
export function convertStringAmountToCurrencyAndSignDirectionForLanguage(
  amount,
  language,
  currencySignSingle,
  currencySignMultiple,
  currencyRate
) {
  console.log(
    'convertStringAmountToCurrencyAndSignDirectionForLanguage',
    amount,
    language,
    currencySignSingle,
    currencySignMultiple,
    currencyRate
  );

  if (!language) language = 'en';
  if (!currencySignSingle) currencySignSingle = 'unknown currency';
  if (!currencySignMultiple) currencySignMultiple = 'unknown currencies';

  const amountX = parseFloat(amount) || 0;
  const currencyRateX = parseFloat(currencyRate) || 1;
  const convertedAmount = amountX * currencyRateX;

  const displayPrice = new Intl.NumberFormat(language, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(convertedAmount);

  const symbolDirection = getCurrencyCultureSymbolOnLeftOrRight(language);

  console.log('Currency symbol direction:', symbolDirection);

  const result =
    symbolDirection === 'right'
      ? `${displayPrice} ${currencySignMultiple}`
      : `${currencySignMultiple} ${displayPrice}`;

  console.log('Formatted result:', result);

  return result;
}

// Map Stripe card brand names to image paths
export function convertStripeCardBrandNameToImage(stripeBrandName) {
  const map = {
    visa: 'visa.svg',
    amex: 'amex.svg',
    unionpay: 'unionpay.svg',
    mastercard: 'mastercard.svg',
    discover: 'discover.svg',
    diners: 'dinersclub.svg',
    jcb: 'jcb.svg',
  };
  return map[stripeBrandName] || 'unknown.svg';
}

// Map Stripe card brand names to simplified names
export function convertStripeCardBrandNameToSimpleName(stripeBrandName) {
  const map = {
    visa: 'visa',
    amex: 'amex',
    unionpay: 'unionpay',
    mastercard: 'mastercard',
    discover: 'discover',
    diners: 'diners',
    jcb: 'jcb',
  };
  return map[stripeBrandName] || stripeBrandName;
}

// Map Stripe card brand names to full names
export function convertStripeCardBrandNameToFullName(stripeBrandName) {
  const map = {
    visa: 'Visa',
    amex: 'American Express',
    unionpay: 'UnionPay',
    mastercard: 'Mastercard',
    discover: 'Discover',
    diners: 'Diners Club',
    jcb: 'JCB',
  };
  return map[stripeBrandName] || stripeBrandName;
}

// Map Stripe card brand names to IDs
export function convertStripeCardBrandNameToID(stripeBrandName) {
  const map = {
    visa: 1,
    amex: 4,
    unionpay: 6,
    mastercard: 3,
    discover: 9,
    diners: 8,
    jcb: 7,
  };
  return map[stripeBrandName] || 0;
}
